module.exports = __webpack_public_path__ + "static/media/fly0021.47f5c7a9.webp";